import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "pipeFilter",
  standalone: false,
})
export class PipeFilter implements PipeTransform {
  public transform(data, keys: string, term: string) {
    if (!term || !data || !keys) return data;

    return data.filter((item) =>
      keys
        .split(",")
        .some((key) => item.hasOwnProperty(key) && new RegExp(term, "gi").test(item[key]))
    );
  }
}
